import ApiService, { HTTPMethod } from './api.core'
import { Transformer } from '../models/Transformer'

class PolicyManagementRenewalApi {
  async _parseInsuranceResponse(promise) {
    let res = await promise
    if (res.ok && res.data) {
      res.parsedData = Transformer.parseActiveInsuranceModel(res.data)
    }
    return res
  }

  async getSubscriptionRenewalOffers(insuranceId) {
    let res = await ApiService.fetch(
      `insurances/${insuranceId}/renewal/offers`,
      HTTPMethod.GET
    )
    if (res.ok && res.data.offers) {
      res.parsedData = Transformer.parseLiabilityLimitExtentionOffers(
        res.data.offers
      ).sort((a, b) => a.liabilityLimit - b.liabilityLimit)
    }
    return res
  }

  async applyLiabilityLimit(insuranceId, liabilityLimit) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/liability-limit`,
        HTTPMethod.PUT,
        {
          liability_limit: liabilityLimit,
        }
      )
    )
  }

  async addDrone(insuranceId, drone) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/drones`,
        HTTPMethod.POST,
        drone
      )
    )
  }

  async editDrone(insuranceId, drone) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/drones/${drone.id}`,
        HTTPMethod.PUT,
        drone
      )
    )
  }

  async deleteDrone(insuranceId, droneId) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/drones/${droneId}`,
        HTTPMethod.DELETE
      )
    )
  }

  async addEquipment(insuranceId, equipment) {
    equipment.quantity = parseFloat(equipment.quantity)
    equipment.value = parseFloat(equipment.value)
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/equipment`,
        HTTPMethod.POST,
        equipment
      )
    )
  }

  async editEquipment(insuranceId, equipment) {
    equipment.quantity = parseFloat(equipment.quantity)
    equipment.value = parseFloat(equipment.value)
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/equipment/${equipment.id}`,
        HTTPMethod.PUT,
        equipment
      )
    )
  }

  async deleteEquipment(insuranceId, equipmentId) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/equipment/${equipmentId}`,
        HTTPMethod.DELETE
      )
    )
  }

  async addAdditionalInsured(insuranceId, ai) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/additional-insureds`,
        HTTPMethod.POST,
        ai
      )
    )
  }

  async sendAutoRenewCancelReason(
    insuranceId,
    policy_number,
    cancellation_reason,
    cancellation_note
  ) {
    let res = await ApiService.fetch(
      `insurances/${insuranceId}/renewal/cancel-reason`,
      HTTPMethod.POST,
      {
        policy_number: policy_number,
        cancellation_reason: cancellation_reason,
        cancellation_note: cancellation_note,
      }
    )
  }

  async editAdditionalInsured(insuranceId, ai) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/additional-insureds/${ai.id}`,
        HTTPMethod.PUT,
        ai
      )
    )
  }

  async deleteAdditionalInsured(insuranceId, ai) {
    return await this._parseInsuranceResponse(
      ApiService.fetch(
        `insurances/${insuranceId}/renewal/additional-insureds/${ai.id}`,
        HTTPMethod.DELETE
      )
    )
  }
}

export default new PolicyManagementRenewalApi()
